import styled from "styled-components";
import colors from "../../constants/colors";

export const NoItemsText = styled("p")({
  fontSize: "1rem",
  color: colors.GREY_7,
  textAlign: "center",
  margin: "1rem 0",
});
